import { render } from "./SvgIcon.vue?vue&type=template&id=e9065dd8&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=e9065dd8&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-e9065dd8"

export default script